import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListTeamMembers from "../Components/Team Members/listTeamMembers";
import AddTeamMember from "../Components/Team Members/addTeamMember";
import EditTeamMember from "../Components/Team Members/EditTeamMember";
import ViewTeamMember from "../Components/Team Members/viewTeamMember";

const TeamRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/team" element={<ListTeamMembers></ListTeamMembers>}></Route>
      <Route path="/team/add" element={canAdd ? <AddTeamMember /> : <Navigate to="/team" replace />}></Route>
      <Route
        path="/team/edit/:id"
        element={canEdit ? <EditTeamMember /> : <Navigate to="/team" replace />}
      ></Route>
      <Route path="/team/view/:id" element={<ViewTeamMember />}></Route>
    </Routes>
  );
};

export default TeamRoutes;
